<template>
    <div>
        <!-- 首页不需要面包屑导航，已注释
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>财务统计</el-breadcrumb-item>
            <el-breadcrumb-item>财务统计数据</el-breadcrumb-item>
        </el-breadcrumb>
        <br>
        -->
        <el-row :gutter="20">
            <el-col :span="6">
                <el-select 
                    v-model="queryInfo.query"  
                    placeholder="请选择门店" 
                    @change="getData" 
                    @click.native="handleStoreSelectClick"
                    @focus="handleStoreSelectFocus"
                    class="seltect" 
                    style="width: 350px;" 
                    clearable  
                    filterable>
                    <el-option v-for="item in stores" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                </el-select>
            </el-col>
            <el-col :span="6">
                    <el-date-picker
                    v-model="customdate"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions" @change="CustomeDate">
                    </el-date-picker>
            </el-col>
        </el-row>
        <div style="height: 20px;"></div>
        <el-row :gutter="20">
            <el-col :span="18">
                <el-card>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-card style="background-image: linear-gradient(to right,#f7e990,#fcdd34);border-radius: 10px;">
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="display: flex;">  
                                        <img src="../assets/image/yuan.png" style="width: 20px;height:20px;vertical-align: middle;margin-top: 10px;"></img>
                                        <div style="padding-left: 20px;">
                                            <div style="font-size: 25px;font-weight: bold;padding-bottom: 20px;">今天</div>
                                            <div style="font-size: 25px;font-weight: bold;">{{today.total_income}}元</div>
                                        </div>
                                    </div>
                                    <div >
                                        <img src="../assets/image/zong.png" style="height: 200px;vertical-align: middle;margin-right: -80px;margin-top: -80px;" />
                                    </div>
                                </div>
                                <div style="height: 50px;"></div>
                                <div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">抖音验劵：</div>
                                            <div>{{today.douyin_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">抖音退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{today.douyin_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">美团验劵：</div>
                                            <div>{{today.meituan_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">美团退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{today.meituan_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">高德验劵：</div>
                                            <div>{{today.gaode_income || '0'}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">高德退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{today.gaode_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">平台收入：</div>
                                            <div>{{today.xiaochengxu_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">平台退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{today.xiaochengxu_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">异业验券：</div>
                                            <div>{{today.yiye_income || '0'}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">异业退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{today.yiye_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card style="background-image: linear-gradient(to right,#b8dafe,#30b0f9);border-radius: 10px;">
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="display: flex;">  
                                        <img src="../assets/image/yuan.png" style="width: 20px;height:20px;vertical-align: middle;margin-top: 10px;"></img>
                                        <div style="padding-left: 20px;">
                                            <div style="font-size: 25px;font-weight: bold;padding-bottom: 20px;">昨天</div>
                                            <div style="font-size: 25px;font-weight: bold;">{{yestoday.total_income}}元</div>
                                        </div>
                                    </div>
                                    <div >
                                        <img src="../assets/image/zong.png" style="height: 200px;vertical-align: middle;margin-right: -80px;margin-top: -80px;" />
                                    </div>
                                </div>
                                <div style="height: 50px;"></div>
                                <div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">抖音验劵：</div>
                                            <div>{{yestoday.douyin_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">抖音退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{yestoday.douyin_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">美团验劵：</div>
                                            <div>{{yestoday.meituan_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">美团退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{yestoday.meituan_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">高德验劵：</div>
                                            <div>{{yestoday.gaode_income || '0'}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">高德退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{yestoday.gaode_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">平台收入：</div>
                                            <div>{{yestoday.xiaochengxu_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">平台退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{yestoday.xiaochengxu_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">异业验券：</div>
                                            <div>{{yestoday.yiye_income || '0'}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">异业退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{yestoday.yiye_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card style="background-image: linear-gradient(to right,#ffeee0,#f6be8b); border-radius: 10px;">
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="display: flex;">  
                                        <img src="../assets/image/yuan.png" style="width: 20px;height:20px;vertical-align: middle;margin-top: 10px;"></img>
                                        <div style="padding-left: 20px;">
                                            <div style="font-size: 25px;font-weight: bold;padding-bottom: 20px;">近七天</div>
                                            <div style="font-size: 25px;font-weight: bold;">{{last_7_days.total_income}}元</div>
                                        </div>
                                    </div>
                                    <div >
                                        <img src="../assets/image/zong.png" style="height: 200px;vertical-align: middle;margin-right: -80px;margin-top: -80px;" />
                                    </div>
                                </div>
                                <div style="height: 50px;"></div>
                                <div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">抖音验劵：</div>
                                            <div>{{last_7_days.douyin_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">抖音退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_7_days.douyin_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">美团验劵：</div>
                                            <div>{{last_7_days.meituan_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">美团退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_7_days.meituan_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">高德验劵：</div>
                                            <div>{{last_7_days.gaode_income || '0'}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">高德退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_7_days.gaode_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">平台收入：</div>
                                            <div>{{last_7_days.xiaochengxu_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">平台退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_7_days.xiaochengxu_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">异业验券：</div>
                                            <div>{{last_7_days.yiye_income || '0'}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">异业退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_7_days.yiye_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                    <br>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-card style="background-image: linear-gradient(to right,#f8dadb,#f69798);border-radius: 10px;">
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="display: flex;">  
                                        <img src="../assets/image/yuan.png" style="width: 20px;height:20px;vertical-align: middle;margin-top: 10px;"></img>
                                        <div style="padding-left: 20px;">
                                            <div style="font-size: 25px;font-weight: bold;padding-bottom: 20px;">上月</div>
                                            <div style="font-size: 25px;font-weight: bold;">{{last_month.total_income}}元</div>
                                        </div>
                                    </div>
                                    <div >
                                        <img src="../assets/image/zong.png" style="height: 200px;vertical-align: middle;margin-right: -80px;margin-top: -80px;" />
                                    </div>
                                </div>
                                <div style="height: 50px;"></div>
                                <div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">抖音验劵：</div>
                                            <div>{{last_month.douyin_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">抖音退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_month.douyin_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">美团验劵：</div>
                                            <div>{{last_month.meituan_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">美团退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_month.meituan_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">高德验劵：</div>
                                            <div>{{last_month.gaode_income || '0'}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">高德退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_month.gaode_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">平台收入：</div>
                                            <div>{{last_month.xiaochengxu_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">平台退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_month.xiaochengxu_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">异业验券：</div>
                                            <div>{{last_month.yiye_income || '0'}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">异业退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_month.yiye_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card style="background-image: linear-gradient(to right,#a8f8bd,#54cd74);border-radius: 10px;">
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="display: flex;">  
                                        <img src="../assets/image/yuan.png" style="width: 20px;height:20px;vertical-align: middle;margin-top: 10px;"></img>
                                        <div style="padding-left: 20px;">
                                            <div style="font-size: 25px;font-weight: bold;padding-bottom: 20px;">近三个月</div>
                                            <div style="font-size: 25px;font-weight: bold;">{{last_3_months.total_income}}元</div>
                                        </div>
                                    </div>
                                    <div >
                                        <img src="../assets/image/zong.png" style="height: 200px;vertical-align: middle;margin-right: -80px;margin-top: -80px;" />
                                    </div>
                                </div>
                                <div style="height: 50px;"></div>
                                <div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">抖音验劵：</div>
                                            <div>{{last_3_months.douyin_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">抖音退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_3_months.douyin_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">美团验劵：</div>
                                            <div>{{last_3_months.meituan_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">美团退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_3_months.meituan_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">高德验劵：</div>
                                            <div>{{last_3_months.gaode_income || '0'}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">高德退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_3_months.gaode_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">平台收入：</div>
                                            <div>{{last_3_months.xiaochengxu_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">平台退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_3_months.xiaochengxu_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">异业验券：</div>
                                            <div>{{last_3_months.yiye_income || '0'}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">异业退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_3_months.yiye_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card style="background-image: linear-gradient(to right,#cbd8fb,#839bfc); border-radius: 10px;">
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="display: flex;">  
                                        <img src="../assets/image/yuan.png" style="width: 20px;height:20px;vertical-align: middle;margin-top: 10px;"></img>
                                        <div style="padding-left: 20px;">
                                            <div style="font-size: 25px;font-weight: bold;padding-bottom: 20px;">近半年</div>
                                            <div style="font-size: 25px;font-weight: bold;">{{last_6_months.total_income}}元</div>
                                        </div>
                                    </div>
                                    <div >
                                        <img src="../assets/image/zong.png" style="height: 200px;vertical-align: middle;margin-right: -80px;margin-top: -80px;" />
                                    </div>
                                </div>
                                <div style="height: 50px;"></div>
                                <div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">抖音验劵：</div>
                                            <div>{{last_6_months.douyin_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">抖音退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_6_months.douyin_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">美团验劵：</div>
                                            <div>{{last_6_months.meituan_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">美团退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_6_months.meituan_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">高德验劵：</div>
                                            <div>{{last_6_months.gaode_income || '0'}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">高德退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_6_months.gaode_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">平台收入：</div>
                                            <div>{{last_6_months.xiaochengxu_income}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">平台退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_6_months.xiaochengxu_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                    <div style="display: flex;padding: 10px;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="width: 80px;">异业验券：</div>
                                            <div>{{last_6_months.yiye_income || '0'}}元</div>
                                        </div>
                                        <div style="flex: 1; display: flex; justify-content: flex-end;">
                                            <div style="width: 80px; text-align: left;">异业退款：</div>
                                            <div style="min-width: 50px; text-align: left;">{{last_6_months.yiye_refund || '0'}}元</div>
                                        </div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
            <el-col :span="6">
                <!-- {{ customdate }} -->
                <el-card style="height: 665px;">
                    <el-card v-if="customdate !== null && customdate.length > 0" style="background-image: linear-gradient(to right,#5bb1d7,#068eca); border-radius: 10px;color: #eee;">
                        <div style="display: flex;justify-content: space-between;">
                            <div style="display: flex;">  
                                <img src="../assets/image/yuan.png" style="width: 20px;height:20px;vertical-align: middle;margin-top: 10px;"></img>
                                <div style="padding-left: 20px;">
                                    <div style="font-size: 25px;font-weight: bold;padding-bottom: 20px;">{{customdate[0]}} 至 {{ customdate[1] }}</div>
                                    <div style="font-size: 25px;font-weight: bold;">{{custom_date.total_income}}元</div>
                                </div>
                            </div>
                            <div >
                                <img src="../assets/image/zong.png" style="height: 200px;vertical-align: middle;margin-right: -80px;margin-top: -80px;" />
                            </div>
                        </div>
                        <div style="height: 50px;"></div>
                        <div style="color: #eee;">
                            <div style="display: flex;padding: 10px;">
                                <div style="flex: 1; display: flex;">
                                    <div style="width: 80px;">抖音验劵：</div>
                                    <div>{{custom_date.douyin_income}}元</div>
                                </div>
                                <div style="flex: 1; display: flex; justify-content: flex-end;">
                                    <div style="width: 80px; text-align: left;">抖音退款：</div>
                                    <div style="min-width: 50px; text-align: left;">{{custom_date.douyin_refund || '0'}}元</div>
                                </div>
                            </div>
                            <div style="display: flex;padding: 10px;">
                                <div style="flex: 1; display: flex;">
                                    <div style="width: 80px;">美团验劵：</div>
                                    <div>{{custom_date.meituan_income}}元</div>
                                </div>
                                <div style="flex: 1; display: flex; justify-content: flex-end;">
                                    <div style="width: 80px; text-align: left;">美团退款：</div>
                                    <div style="min-width: 50px; text-align: left;">{{custom_date.meituan_refund || '0'}}元</div>
                                </div>
                            </div>
                            <div style="display: flex;padding: 10px;">
                                <div style="flex: 1; display: flex;">
                                    <div style="width: 80px;">高德验劵：</div>
                                    <div>{{custom_date.gaode_income || '0'}}元</div>
                                </div>
                                <div style="flex: 1; display: flex; justify-content: flex-end;">
                                    <div style="width: 80px; text-align: left;">高德退款：</div>
                                    <div style="min-width: 50px; text-align: left;">{{custom_date.gaode_refund || '0'}}元</div>
                                </div>
                            </div>
                            <div style="display: flex;padding: 10px;">
                                <div style="flex: 1; display: flex;">
                                    <div style="width: 80px;">平台收入：</div>
                                    <div>{{custom_date.xiaochengxu_income}}元</div>
                                </div>
                                <div style="flex: 1; display: flex; justify-content: flex-end;">
                                    <div style="width: 80px; text-align: left;">平台退款：</div>
                                    <div style="min-width: 50px; text-align: left;">{{custom_date.xiaochengxu_refund || '0'}}元</div>
                                </div>
                            </div>
                            <div style="display: flex;padding: 10px;">
                                <div style="flex: 1; display: flex;">
                                    <div style="width: 80px;">异业验券：</div>
                                    <div>{{custom_date.yiye_income || '0'}}元</div>
                                </div>
                                <div style="flex: 1; display: flex; justify-content: flex-end;">
                                    <div style="width: 80px; text-align: left;">异业退款：</div>
                                    <div style="min-width: 50px; text-align: left;">{{custom_date.yiye_refund || '0'}}元</div>
                                </div>
                            </div>
                        </div>
                    </el-card>
                    <div v-else style="text-align: center;padding-top: 100px;">
                        <img src="../assets/image/null.png" style="height: 200px;" />
                        <div style="text-align: center;color:#ccc">暂无信息</div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <div style="height: 20px;"></div>
        
        <!-- 收入统计组件（不含预警） -->
        <revenue-statistics-home></revenue-statistics-home>
        
        <!-- 暂时注释掉月度和年度销量统计
        <div style="height: 20px;"></div>
        <el-card>
            <div slot="header" class="clearfix">
                <span style="font-size: 20px;font-weight: bold;">{{month1}}月度销量统计</span>
                <el-date-picker style="float: right" v-model="month1" value-format="yyyy-MM" type="month" placeholder="选择月" @change="ChangeMonth()" :clearable="false" :editable="false"></el-date-picker>
            </div>
            <div ref="MonthContainer" style="width: 100%; height: 400px;"></div>
        </el-card>
        <div style="height: 20px;"></div>
        <el-card>
            <div slot="header" class="clearfix">
                <span style="font-size: 20px;font-weight: bold;">{{year1}}年度销量统计</span>
                <el-date-picker style="float: right" v-model="year1" value-format="yyyy" type="year" placeholder="选择年" @change="ChangeYear()" :clearable="false" :editable="false"></el-date-picker>
            </div>
            <div ref="YearContainer" style="width: 100%; height: 400px;"></div>
        </el-card>
        -->
    </div>
</template>

<script>
import * as echarts from 'echarts';
import RevenueStatisticsHome from './Statistics/RevenueStatistics.vue';

export default {
    components: {
        RevenueStatisticsHome
    },
    data() {
        return{
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            customdate:'',
            stores:[],
            queryInfo: {
                query: '',
                startdate: '',
                enddate: ''
            },
            today:{},
            yestoday:{},
            last_7_days:{},
            last_month:{},
            last_3_months:{},
            last_6_months:{},
            custom_date:{},
            month1:this.getCurrentYearMonth(),
            days:[],
            datas:[],
            year1:this.getCurrentYear(),
            months:[],
            ydatas:[],
        }
    },
    async created() {
        // 先获取门店列表，再获取统计数据
        await this.getStoreList()
        await this.getData()
        // 月度和年度图表已注释，不再加载数据
        // await this.getEchartMData();
        // await this.getEchartYData();
    },
    mounted(){
        // 月度和年度图表已注释，不再渲染
        // if (this.datas.length) {
        //     this.showEchart();
        // }
    },
    watch: {
        // 月度和年度图表已注释，不再监听数据变化
        // datas(newVal) {
        //     if (newVal.length) {
        //         this.showEchart();
        //     }
        // },
        // ydatas(newVal) {
        //     if (newVal.length) {
        //         this.showEchart();
        //     }
        // }
    },
    methods:{
        // 分离获取门店列表和获取统计数据的方法
        async getStoreList() {
            try {
                const { data: res } = await this.$http.get('store/')
                if (res.status == 0) {
                    this.stores = res.data
                    console.log('获取门店列表成功', this.stores)
                }
            } catch (error) {
                console.error('获取门店列表失败', error)
                this.$message.error('获取门店列表失败')
            }
        },
        
        async getData() {
            try {
                // 如果门店列表为空，先获取门店列表
                if (this.stores.length === 0) {
                    await this.getStoreList()
                }
                
                const { data: res } = await this.$http.post('tongji/', this.queryInfo)
                if (res.status == 0) {
                    // 不再从统计接口获取门店列表，避免覆盖
                    // this.stores = res.data.stores
                    this.today = res.data.periods.today
                    this.yestoday = res.data.periods.yesterday
                    this.last_7_days = res.data.periods.last_7_days
                    this.last_month = res.data.periods.last_month
                    this.last_3_months = res.data.periods.last_3_months
                    this.last_6_months = res.data.periods.last_6_months
                    this.custom_date = res.data.custom_income
                }
            } catch (error) {
                console.error('获取统计数据失败', error)
                this.$message.error('获取统计数据失败')
            }
            
            // 异步调用图表数据获取方法，不阻塞主流程
            this.getEchartMData().catch(error => {
                console.error('异步获取月度图表数据失败', error)
            })
            this.getEchartYData().catch(error => {
                console.error('异步获取年度图表数据失败', error)
            })
        },
        // 处理门店选择框点击事件
        handleStoreSelectClick() {
            // 确保每次点击时都刷新门店列表
            this.getStoreList()
        },
        
        // 处理门店选择框获得焦点事件
        handleStoreSelectFocus() {
            // 确保每次获得焦点时都刷新门店列表
            this.getStoreList()
        },
        
        CustomeDate(){
            // console.log(this.customdate);
            if(this.customdate === null || this.customdate.length === 0){
                this.queryInfo.startdate = ''
                this.queryInfo.enddate = ''
            }else{
                this.queryInfo.startdate = this.customdate[0]
                this.queryInfo.enddate = this.customdate[1]
            }
            this.getData()
        },
        async getEchartMData(){
            try {
                const { data: res} = await this.$http.get('echartsmonthdata/',{params:{rq:this.month1,storeid:this.queryInfo.query}})
                if(res.status == 0){
                    this.days = res.days
                    this.datas = res.data;
                    console.log(this.datas)
                } else {
                    console.error('获取月度图表数据失败', res)
                }
            } catch (error) {
                console.error('获取月度图表数据异常', error)
                this.$message.error('获取月度图表数据失败')
            }
        },
        async getEchartYData(){
            try {
                const { data: res} = await this.$http.get('echartsyeardata/',{params:{rq:this.year1,storeid:this.queryInfo.query}})
                if(res.status == 0){
                    this.months = res.months
                    this.ydatas = res.data;
                } else {
                    console.error('获取年度图表数据失败', res)
                }
            } catch (error) {
                console.error('获取年度图表数据异常', error)
                this.$message.error('获取年度图表数据失败')
            }
        },
        // 渲染图表
        showEchart() {
            // 初始化ECharts实例
            const myChartMonth = echarts.init(this.$refs.MonthContainer);
            const myChartYear = echarts.init(this.$refs.YearContainer);
            // 使用刚指定的配置项和数据显示图表
            myChartMonth.setOption({
                title: {
                    text: '单位(元)',
                    textStyle: {
                        color: "rgb(85, 85, 85)",
                        fontSize: 18,
                        fontStyle: "normal",
                        fontWeight: "normal"
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    data: ['总金额', '平台', '抖音', '美团', '退款'],
                    selectedMode: true,
                },
                toolbox: {
                    show: true,
                        feature: {
                            dataView: {
                                show: false,
                                readOnly: true
                            },
                            magicType: {
                                show: true,
                                type: ["line", "bar", "stack", "tiled"]
                            },
                            restore: {
                                show: true
                            },
                            saveAsImage: {
                                show: true
                            },
                            mark: {
                                show: false
                            }
                        }
                },
                calculable: false,
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: this.days
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: this.datas.map(item => ({
                    name: item.name,
                    type: 'line',
                    // stack: 'Total',
                    smooth: true,
                    areaStyle: {},
                    emphasis: {
                        focus: 'series'
                    },
                    data: item.data
                }))
            });
            myChartYear.setOption({
                title: {
                    text: '单位(元)',
                    textStyle: {
                        color: "rgb(85, 85, 85)",
                        fontSize: 18,
                        fontStyle: "normal",
                        fontWeight: "normal"
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    data: ['总金额', '平台', '抖音', '美团', '退款'],
                    selectedMode: true,
                },
                toolbox: {
                    show: true,
                        feature: {
                            dataView: {
                                show: false,
                                readOnly: true
                            },
                            magicType: {
                                show: true,
                                type: ["line", "bar", "stack", "tiled"]
                            },
                            restore: {
                                show: true
                            },
                            saveAsImage: {
                                show: true
                            },
                            mark: {
                                show: false
                            }
                        }
                },
                calculable: false,
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: true,
                        data: this.months
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: this.ydatas.map(item => ({
                    name: item.name,
                    type: 'bar',
                    // stack: 'Total',
                    // smooth: true,
                    areaStyle: {},
                    emphasis: {
                        focus: 'series'
                    },
                    data: item.data
                }))
            });
        },
        ChangeMonth(){
            this.getEchartMData().catch(error => {
                console.error('切换月份时获取图表数据失败', error)
            })
        },
        getCurrentYearMonth() {
            const now = new Date();
            const year = now.getFullYear();
            const month = (now.getMonth() + 1).toString().padStart(2, '0');  // 确保月份是两位数
            return `${year}-${month}`;
        },
        getCurrentYear() {
            const now = new Date();
            const year = now.getFullYear();
            return `${year}`;
        },
        ChangeYear(){
            this.getEchartYData().catch(error => {
                console.error('切换年份时获取图表数据失败', error)
            })
        },
    }
}
</script>
<style scoped>
    .el-breadcrumb{
        width: 100%;
    }
</style>